<app-header></app-header>

<main class="main">
  <section>
    <app-toaster class="toaster-bottom"></app-toaster>
    <router-outlet />
  </section>
</main>



